'use client'

import { useContext, useEffect } from 'react'

import { HeaderContext } from '@/context/HeaderContext'

import type { PageType } from '@/types/contentful/pageType'

export default function HeaderDataProvider({ page }: { page: PageType | null }) {
  const { setHeaderType } = useContext(HeaderContext)
  useEffect(() => {
    setHeaderType(page?.fields?.transparentHeader ? 'transparent' : 'solid')
  }, [page, setHeaderType])

  return null
}
